exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.registration-success-content {\n    text-align: center;\n    margin-top: 140px;\n    padding-bottom: 0px;\n}\n#sign-up {\n    height: 100%;\n    padding: 0;\n    margin: 0 !important;\n    background-color: transparent;\n}\n#sign-up .sign-in-link {\n        margin-top: 30px !important;\n        margin-bottom: 40px;\n}\n#sign-up .register-form {\n        margin: 20px auto;\n}\n#sign-up .error-message {\n        color: #ee653b;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-56fefc16!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./modules/sign-up-page/SignUpPage.vue
// module id = 2830
// module chunks = 37